import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ForgottenPassword from '../../../common/forgottenPassword';
import { selectors as bookmakersListSelectors } from '../../../common/bookmakersList';
import { selectors as bookmakersInfoSelectors } from '../../../common/bookmakersInfo';

export const ForgottenPasswordPage = ({ match }) => (
    <div className="bs-horizontalSlider__element">
        <div className="bs-drawer__content">
            <ForgottenPassword match={match} />
        </div>
    </div>
);

ForgottenPasswordPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            feed: PropTypes.string,
        }),
    }).isRequired,
};

const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        bookmakersInfoSelectors.betBookmakerSelector,
    );

const mapStateToProps = state => (
    { ...bookmakerInfoSelector(state) }
);

export default connect(
    mapStateToProps,
    null,
)(ForgottenPasswordPage);



// WEBPACK FOOTER //
// /src/js/drawer/components/ForgottenPasswordPage/ForgottenPasswordPage.jsx